import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext.js";
import LandingPage from "./pages/LandingPage.js";
import LowBackPain from "./pages/learn/LowBackPain.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import TermsAndConditions from "./pages/TermsAndConditions.js";
import DisclaimerPage from "./pages/DisclaimerPage.js";
import RefundPage from "./pages/RefundPage.js";
import Contact from "./pages/Contact.js";
import AppEntry from "./components/AppEntry.js";
import HomePage from "./pages/HomePage.js";
import Diagnosis from "./pages/Diagnosis.js";
import CardioPulmonaryForm from "./pages/CardioPulmonaryForm.js";
import NeuroSubjectiveForm from "./pages/NeuroSubjectiveForm.js";
import SubjectiveOrthoForm from "./pages/SubjectiveOrthoForm.js";
import Refer from "./pages/Refer.js";
import AdminReferrals from "./pages/AdminReferrals.js";
import ProtectedRoute, { GuestRoute } from "./components/ProtectedRoute.js";
import NotFound from "./pages/NotFound.js";

function App() {
  return (
    <ThemeProvider>
    <BrowserRouter>
      <Routes>
        {/* ── Public ── */}
        <Route path="/" element={<GuestRoute><LandingPage /></GuestRoute>} />
        <Route path="/app" element={<GuestRoute><AppEntry /></GuestRoute>} />
        <Route path="/learn/low-back-pain" element={<LowBackPain />} />
        <Route path="/privacy"     element={<PrivacyPolicy />} />
        <Route path="/terms"       element={<TermsAndConditions />} />
        <Route path="/disclaimer"  element={<DisclaimerPage />} />
        <Route path="/refund"      element={<RefundPage />} />
        <Route path="/contact"     element={<Contact />} />

        {/* ── Protected app ── */}
        <Route path="/home"              element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        <Route path="/refer"             element={<ProtectedRoute><Refer /></ProtectedRoute>} />
        <Route path="/admin/referrals"   element={<ProtectedRoute><AdminReferrals /></ProtectedRoute>} />
        <Route path="/diagnosis"         element={<ProtectedRoute><Diagnosis /></ProtectedRoute>} />
        <Route path="/cardio-form"       element={<ProtectedRoute><CardioPulmonaryForm /></ProtectedRoute>} />
        <Route path="/ortho-form"        element={<ProtectedRoute><SubjectiveOrthoForm /></ProtectedRoute>} />
        <Route path="/neuro-form"        element={<ProtectedRoute><NeuroSubjectiveForm /></ProtectedRoute>} />

        {/* ── 404 ── */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
